import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.some";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.filter";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from '@/store';
// import { msgPageList, getInfo } from '@/api/systemManagement/system'
import { pro, setting } from '@/utils/settings';
import { getCurrentProInfo } from '@/utils';
import { getCatRepair } from '@/api/workTable/worker';
import RepairBox from "./RepairBox";
import CropperDialog from '@/components/VueCropper/index.vue';
import { uploadFile, updateAvatar } from '@/api/common/system';
import SideMenu from "./SideMenu/index";
import { queryUnionList } from '@/api/common/user';
import { unreadCount } from '@/api/systemManagement/message';
export default _defineProperty(_defineProperty({
  components: {
    RepairBox: RepairBox,
    SideMenu: SideMenu,
    CropperDialog: CropperDialog
  },
  data: function data() {
    return {
      isRead: false,
      status: '',
      // 注册审核状态
      // cip: '',
      // cname: '',
      UnionList: [],
      showLeftArrow: false,
      showRightArrow: false,
      // 获取推送消息的定时器
      timer: null,
      msgNum: '0',
      buttonControl: []
    };
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    },
    code: function code() {
      return this.$store.state.user.code;
    },
    addRouters: function addRouters() {
      return this.$store.state.permission.addRouters;
    },
    projects: function projects() {
      var _this = this;
      if (this.$store.state.permission.projects) {
        var memuList = this.$store.state.permission.projects.filter(function (item) {
          var firstLevelList = _this.addRouters.find(function (ele) {
            return ele.name === item.permissionKey;
          });
          return item.visible === '0' && item.permissionKey !== 'mobileComponents' && firstLevelList && firstLevelList.children;
        });
        return memuList;
      }
      return [];
    },
    defaultLogo: function defaultLogo() {
      return require('@/assets/images/ilabecoLogo/yq_logo.png');
    },
    logoutUrl: function logoutUrl() {
      return getCurrentProInfo(pro, setting).logoutUrl;
    },
    VUE_APP_AFTER_SALES_URL: function VUE_APP_AFTER_SALES_URL() {
      return getCurrentProInfo(pro, setting)[process.env.NODE_ENV].VUE_APP_AFTER_SALES_URL;
    },
    projectDesc: function projectDesc() {
      return getCurrentProInfo(pro, setting).projectDesc;
    },
    // 租户名称
    tenantName: function tenantName() {
      var userInfo = this.$store.state.user.userInfo;
      return userInfo && userInfo.tenantName || '';
    },
    // 租户logo
    logoUrl: function logoUrl() {
      var userInfo = this.$store.state.user.userInfo;
      return userInfo && userInfo.logoUrl || '';
    },
    // 报修微信群图片链接
    repairWechatImg: function repairWechatImg() {
      var _this$$store$state$us = this.$store.state.user,
        user = _this$$store$state$us === void 0 ? {} : _this$$store$state$us;
      var _ref = user && user.userInfo || {},
        _ref$repair_wechat_im = _ref.repair_wechat_img,
        repair_wechat_img = _ref$repair_wechat_im === void 0 ? '' : _ref$repair_wechat_im;
      return repair_wechat_img;
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    // eslint-disable-next-line no-undef
    // this.cip = returnCitySN['cip']
    // eslint-disable-next-line no-undef
    // this.cname = returnCitySN['cname']
    /* this.isRead = false
    getInfo().then((res) => {
      if (Number(res.code) === 200) {
        this.status = res.data.status
      }
    })
    msgPageList({ parameter: { isRead: 1 }, page: 1, pageSize: 10 }).then(
      (res) => {
        if (Number(res.code) === 200 && res.data && res.data.rows.length > 0) {
          this.isRead = true
        }
      }
    ) */
    if (!pro) {
      this.timer = setInterval(function () {
        _this2.listenMessage();
      }, 2000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener('resize', this.checkOverflow);
    this.timer = null;
    // 解绑事件监听
    if (this.$bus) this.$bus.$off('refreshMessageCount', this.getMessageNum);
  },
  created: function created() {
    this.buttonControl = this.$store.state.permission.allPermissionKey;
    this.getUnionList();
  }
}, "mounted", function mounted() {
  this.checkOverflow();
  window.addEventListener('resize', this.checkOverflow);
  this.getMessageNum();
  // 监听消息数量刷新事件
  if (this.$bus) this.$bus.$on('refreshMessageCount', this.getMessageNum);
}), "methods", {
  // .............................................................................头像：选择图片
  handleAvatarChange: function handleAvatarChange(file) {
    var _this3 = this;
    var raw = file.raw || file;
    var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(raw.type);
    if (!isImage) {
      this.$message.closeAll();
      this.$message.warning('上传图片只能是 JPG、JPEG、PNG 格式!');
      return;
    }
    var isLt5M = raw.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.closeAll();
      this.$message.warning('上传图片大小不能超过 5MB!');
      return;
    }
    // 读取为 base64 喂给 cropper
    var reader = new FileReader();
    reader.onload = function (e) {
      _this3.$refs.avatarCropper.handleShow({
        url: e.target.result,
        name: raw.name
      });
    };
    reader.readAsDataURL(raw);
  },
  // .............................................................................头像：裁剪后上传 + 更新
  handleAvatarCrop: function handleAvatarCrop(data) {
    var _this4 = this;
    var formData = new FormData();
    formData.append('file', data.url, data.name);
    uploadFile(formData).then(function (res) {
      if (Number(res.code) === 200) {
        var avatarUrl = res.data; // 通用上传接口返回的文件 URL
        return updateAvatar({
          avatarUrl: avatarUrl
        }).then(function (r) {
          if (Number(r.code) === 200) {
            // 同步更新 store，头像立即生效
            _this4.$store.commit('user/SET_AVATAR', avatarUrl);
            _this4.$message.success('头像更新成功');
            _this4.$refs.avatarCropper.handleClose();
          } else {
            _this4.$message.error(r.msg || '头像更新失败');
          }
        });
      } else {
        _this4.$message.error(res.msg || '图片上传失败');
      }
    })["catch"](function () {
      _this4.$message.error('图片上传失败');
    });
  },
  // ....................................................................获取消息数量
  getMessageNum: function getMessageNum() {
    var _this5 = this;
    unreadCount().then(function (res) {
      if (Number(res.code) === 200) {
        var data = res && res.data || 0;
        _this5.msgNum = data > 99 ? '99+' : data;
      }
    });
  },
  // ....................................................................跳转消息中心
  toMessage: function toMessage() {
    this.$router.push({
      name: 'message'
    });
  },
  scroll: function scroll(offset) {
    this.$refs.projectList.scrollBy({
      left: offset,
      behavior: 'smooth'
    });
  },
  checkOverflow: function checkOverflow() {
    var container = this.$refs.projectList;
    this.showLeftArrow = container.scrollLeft > 0;
    this.showRightArrow = container.scrollLeft + container.clientWidth < container.scrollWidth;
  },
  handleJump: function handleJump(item) {
    var home = item.unionWebsite.indexOf('home') === -1 ? '/home/' : '';
    window.open("".concat(item.unionWebsite).concat(home, "?token=").concat(this.$ls.get('ACCESS_TOKEN')));
  },
  getUnionList: function getUnionList() {
    var _this6 = this;
    queryUnionList().then(function (res) {
      if (Number(res.code) === 200) {
        _this6.UnionList = res.data;
      }
    });
  },
  getRoutes: function getRoutes(v) {
    return this.addRouters.find(function (item) {
      return item.name === v.permissionKey;
    }).children.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        isparent: true
      });
    });
  },
  // 开启消息监听
  listenMessage: function listenMessage() {
    var _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getCatRepair();
          case 3:
            result = _context.sent;
            if (result.code == 200 && result.data) {
              _this7.$refs.repairBox.handleShow(result.data);
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
  },
  toNotice: function toNotice() {
    this.$router.push('/baseSystem/messageReminding');
  },
  toggleSideBar: function toggleSideBar() {
    if (this.device === 'mobile') {
      this.$store.dispatch('app/toggleSideBar');
    } else {
      this.$router.push("/homeData/home");
    }
  },
  logout: function logout() {
    var _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this8.$store.dispatch('user/logout').then(function () {
              _this8.$router.push("/login");
              // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
            });
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  switchObj: function switchObj(item) {
    var _this9 = this;
    store.commit('permission/currPermissionKey', item.permissionKey);
    // 点击一级菜单跳转到指定的二级菜单, 如果当前用户没有指定的二级菜单权限, 则跳转到第一个有权限的二级菜单
    item.permissionMS.some(function (e) {
      if (item.permissionKey === 'workbench' && e.permissionKey === 'woker') {
        _this9.$router.push("/workbench/woker");
        return true;
      } else if (item.permissionKey === 'workbench' && e.permissionKey === 'afterSalesData') {
        window.open(_this9.VUE_APP_AFTER_SALES_URL, '_blank');
        return true;
      } else if (item.permissionKey === 'approveManage') {
        if (e.permissionKey === 'approveList') {
          _this9.$router.push("/approveManage/approveList");
          return true;
        } else {
          _this9.$router.push("/approveManage/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'maintenanceService') {
        if (e.permissionKey === 'maintenance') {
          _this9.$router.push("/maintenanceService/maintenance");
          return true;
        } else {
          _this9.$router.push("/maintenanceService/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'orderManage') {
        if (e.permissionKey === 'repairList') {
          _this9.$router.push("/orderManage/repairList");
          return true;
        } else {
          _this9.$router.push("/orderManage/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'supplier') {
        // if (e.permissionKey === 'supplierManagement') {
        //   this.$router.push(`/supplier/supplierManagement`)
        //   return true
        // }
        // 暨大改版 v1.5
        if (e.permissionKey === 'providerManagement') {
          _this9.$router.push("/supplier/providerManagement");
          return true;
        } else {
          _this9.$router.push("/supplier/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'financialManagement') {
        if (e.permissionKey === 'settlementManagement') {
          _this9.$router.push("/financialManagement/settlementManagement");
          return true;
        } else {
          _this9.$router.push("/financialManagement/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'visualizeData') {
        if (e.permissionKey === 'school') {
          _this9.$router.push("/visualizeData/school");
          return true;
        } else {
          _this9.$router.push("/visualizeData/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'baseSystem') {
        if (e.permissionKey === 'parameterSet') {
          _this9.$router.push("/baseSystem/parameterSet");
          return true;
        } else {
          _this9.$router.push("/baseSystem/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'learningZone') {
        if (e.permissionKey === 'learning') {
          _this9.$router.push("/learningZone/learning");
          return true;
        } else {
          _this9.$router.push("/learningZone/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'dataStatistics') {
        if (e.permissionKey === 'billStatistics') {
          _this9.$router.push("/dataStatistics/billStatistics");
          return true;
        } else {
          _this9.$router.push("/dataStatistics/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'sparePartsManage') {
        if (e.permissionKey === 'warehousingManage') {
          _this9.$router.push("/sparePartsManage/warehousingManage");
          return true;
        } else {
          var currentKey = item.permissionMS[0].permissionKey;
          var currentRouterArr = item.routes.filter(function (item) {
            return item.includes(currentKey);
          });
          _this9.$router.push(currentRouterArr && currentRouterArr[0]);
        }
      } else if (item.permissionKey === 'leaseManage') {
        if (e.permissionKey === 'leaseDevice') {
          _this9.$router.push("/leaseManage/leaseDevice");
          return true;
        } else {
          _this9.$router.push("/leaseManage/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'homeData') {
        if (e.permissionKey === 'home') {
          _this9.$router.push("/homeData/home");
          return true;
        } else {
          _this9.$router.push("/visualizeData/".concat(item.permissionMS[0].permissionKey));
        }
      } else if (item.permissionKey === 'safeInspection') {
        if (e.permissionKey === 'inspectionTask') {
          _this9.$router.push("/safeInspection/inspectionTask");
          return true;
        } else {
          _this9.$router.push("/safeInspection/".concat(item.permissionMS[0].permissionKey));
        }
      }
    });
  }
});